import { render, staticRenderFns } from "./TeamVoting.vue?vue&type=template&id=1036a019&"
import script from "./TeamVoting.vue?vue&type=script&lang=js&"
export * from "./TeamVoting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports